export default "__VITE_ASSET__ed387097__"